// REGIONS actions
export const REGIONS_GET_LIST = 'REGIONS_GET_LIST';
export const REGIONS_GET_LIST_START = 'REGIONS_GET_LIST_START';
export const REGIONS_GET_LIST_SUCCESS = 'REGIONS_GET_LIST_SUCCESS';
export const REGIONS_GET_LIST_FAILED = 'REGIONS_GET_LIST_FAILED';
